var map = {
	"./Blazor.png": 2631,
	"./astudio.png": 5504,
	"./blender.png": 9739,
	"./c.png": 8416,
	"./english.png": 1371,
	"./git.png": 8075,
	"./github.png": 4830,
	"./godot.png": 2740,
	"./java.png": 2011,
	"./js.png": 5742,
	"./kotlin.png": 2620,
	"./nodejs.png": 8778,
	"./phpicon.png": 2096,
	"./phpmyadmin.png": 6144,
	"./ps.png": 9304,
	"./reactjs.png": 5919,
	"./reactnative.png": 2615,
	"./sechar.png": 1003,
	"./siplusplus.png": 6819,
	"./sql-workbench.png": 871,
	"./sqlsever.png": 6572,
	"./unity.png": 3396,
	"./unreal_engine.png": 9701,
	"./vuejs.png": 1934,
	"./xamarin.png": 1013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6283;